import { render, staticRenderFns } from "./SchoolEdit.vue?vue&type=template&id=f491cc32&"
import script from "./SchoolEdit.js?vue&type=script&lang=js&"
export * from "./SchoolEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports